( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-logo-carousel', {
			speed: 5000,
			autoplay: {
				delay: 1,
				disableOnInteraction: false,
				pauseOnMouseEnter: true
			},
			loop: true,
			slidesPerView: 'auto',
			watchSlidesProgress: true,
			spaceBetween: 40,
			grabCursor: true,
			breakpoints: {
				768: {
					spaceBetween: 60
				},
				1280: {
					spaceBetween: 120
				}
			}
		});
	} );
} )( jQuery, document, window );
